import { render, staticRenderFns } from "./skin-config.vue?vue&type=template&id=535dabe1&scoped=true&"
import script from "./skin-config.vue?vue&type=script&lang=js&"
export * from "./skin-config.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "535dabe1",
  null
  
)

export default component.exports